export const OTP = "code";
export const OTP_FORM_ID = "OtpForm";
export const MFA_CODE_SENT = "mfa-code-sent";
/** error_response.message returned by id-account-auth when the MFA-TOKEN cookie is absent. */
export const MFA_TOKEN_COOKIE_MISSING = "mfa-token-cookie-missing";
/**
 * sessionStorage flag set when the customer has already been sent back to login
 * once because the MFA-TOKEN cookie was missing. If the cookie is missing again
 * after a fresh login, the browser is not keeping cookies at all, so we stop
 * redirecting (which would loop) and show mfaCookieErrorMessage instead.
 */
export const MFA_TOKEN_MISSING_REDIRECTED = "mfa-token-missing-redirected";
/**
 * One-shot sessionStorage flag set just before redirecting to login because the
 * MFA-TOKEN cookie was missing. LoginPage reads and removes it to show
 * mfaSessionExpiredLoginMessage once (a refresh does not show it again).
 */
export const MFA_SESSION_EXPIRED_NOTICE = "mfa-session-expired-notice";
export const mfaSessionExpiredLoginMessage =
  "Your verification session has expired. For your security, please log in again and we'll send you a new code.";
/**
 * sessionStorage key for the recovery_id returned by send-mfa when the
 * MFA-TOKEN cookie is missing. Posted with the login form (and with send-mfa
 * if it fails again) so id-account-auth can log whether the retry succeeded.
 */
export const MFA_RECOVERY_ID = "mfa-recovery-id";
/** Form / query parameter name expected by id-account-auth. */
export const MFA_RECOVERY_ID_PARAM = "mfa_recovery_id";
export const mfaCookieErrorMessage =
  "We couldn't keep you logged in. Please make sure cookies are enabled in your browser, or try a different browser, then log in again.";
/** sessionStorage key for the URL-encoded customer-info JSON returned by send-mfa. */
export const MFA_CUSTOMER_INFO = "mfa-customer-info";
/**
 * sessionStorage key that stores the login_challenge of the flow for which
 * an OTP was last sent.  When a new login_challenge arrives (new OAuth2 flow)
 * the stale MFA_CODE_SENT and MFA_CUSTOMER_INFO entries are cleared so a
 * fresh OTP is always sent for the new challenge.
 */
export const MFA_LOGIN_CHALLENGE = "mfa-login-challenge";

export const accountRecoveryUserData = "account_recovery_user_data";

export const incorrectCodeErrorMessage =
  "Your code is incorrect. Please try again or request a new code.";
export const expiredCodeErrorMessage =
  "Your code has expired. Please request a new code.";
export const maxAttemptsErrorMessage =
  "This code is no longer valid due to too many failed attempts. Please request a new code.";
export const defaultErrorMessage = "Something went wrong. Please try again";

export const requiredMessage = "This field is required";
export const minLengthMessage = (codeLength) =>
  `Your code doesn't look right. Please check it has ${codeLength} digits.`;
export const newCodeMessage =
  "We've sent you a new code, please check your inbox.";
export const newCodeErrorMessage =
  "There has been an error sending the code. Please try again.";
